import { useTranslation } from "react-i18next";
import { ETLCodes } from "../locales";
import { useCallback } from "react";
import { TOptions } from "i18next";

export const useTl = () => {
  const { t, i18n } = useTranslation();

  const tCode = useCallback(
    (code: ETLCodes | string, options?: TOptions<any> | string) => {
      if (typeof code === "string") {
        return t(code, options);
      }
      return t(ETLCodes[code], options);
    },
    [t]
  );

  const tUnsafeCode = useCallback(
    (code: string | undefined, options?: TOptions<any> | string) => {
      if (code === undefined) return "";
      return t(code, options);
    },
    [t]
  );

  return {
    t: tCode,
    tUnsafe: tUnsafeCode,
    i18n,
  };
};
